let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("5p0Ye")]).then(() => parcelRequire('7biA2'));